module.exports = __webpack_public_path__ + "img/star550x450.711e7a13.png";